import React, { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Registerform = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    inviteCode: '',
    user_number: '',
    password: '',
    confirmPassword: ''
  });

  const [error, setError] = useState('');

  // Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle submit
  const handleSubmit = async () => {
    setError('');
  
    if (!formData.user_number || !formData.inviteCode || !formData.password) {
      setError("Please fill all required fields");
      return;
    }
  
    if (formData.user_number.length !== 10) {
      setError("Phone number must be 10 digits");
      return;
    }
  
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
  
    try {
      const res = await axios.post('/api/register/staff', {
        inviteCode: formData.inviteCode,
        user_number: formData.user_number,
        password: formData.password
      });
  
      console.log(res.data);
  
      alert("Signup Successful!");
      navigate('/login');
    } catch (err) {
      console.log(err.response?.data || err.message);
      setError(err.response?.data?.message || "Something went wrong");
    }
  };




  
  return (
    <div className='login-screen'>
      <div className='loginWrapper'>

        <div className='login-icon'>
          <PersonOutlineOutlinedIcon />
        </div>

        {error && (
          <Typography style={{ color: 'red', marginBottom: '10px' }}>
            {error}
          </Typography>
        )}

        <div className='login-form'>

          <TextField
            name="user_number"
            placeholder='Phone Number'
            value={formData.user_number}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="inviteCode"
            placeholder='Invite Code '
            value={formData.inviteCode}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="password"
            type='password'
            placeholder='Password'
            value={formData.password}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="confirmPassword"
            type='password'
            placeholder='Confirm Password'
            value={formData.confirmPassword}
            onChange={handleChange}
            fullWidth
          />

          <Button variant="contained" onClick={handleSubmit}>
            Sign Up
          </Button>

        </div>

        {/* Optional Login Redirect */}
        <Typography style={{ marginTop: '15px', textAlign: 'center' }}>
          Already have an account?{" "}
          <span
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={() => navigate('/login')}
          >
            Login
          </span>
        </Typography>

      </div>
    </div>
  );
};

export default Registerform;